import {
	ScreensaverStateActions,
	SHOW_SCREENSAVER,
	SHOW_TIMEOUT_WARNING,
	RESET_SCREENSAVER_TIMEOUT,
} from './types';

export function showScreensaver(value: boolean): ScreensaverStateActions {
	return {
		type: SHOW_SCREENSAVER,
		value,
	};
}

export function showTimeoutWarning(value: {
	show: boolean;
	sendEvent: boolean;
}): ScreensaverStateActions {
	return {
		type: SHOW_TIMEOUT_WARNING,
		value,
	};
}

export function resetScreensaverTimeout(): ScreensaverStateActions {
	return {
		type: RESET_SCREENSAVER_TIMEOUT,
	};
}
